import { render, staticRenderFns } from "./FinalePopup.vue?vue&type=template&id=109585aa"
import script from "./FinalePopup.vue?vue&type=script&lang=ts"
export * from "./FinalePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports